
import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { Route } from 'vue-router';
import api from '@/api';
import MissionForm from './Form.vue';

const { get, update } = api.mission;
@Component({
  components: { MissionForm },
})
export default class MissionEdit extends Vue {
  @Prop({}) private missionId!: string;

  isValueSetted: boolean = false;

  form: MissionViewModel = {
    missionName: undefined,
    startOn: undefined,
    endOn: undefined,
    isEnabled: undefined,
    simpleDescription: undefined,
    description: undefined,
    isExternalMission: undefined,
    preMissionId: undefined,
    preMissionName: undefined,
    missionAction: undefined,
    merchantId: undefined,
    productType: undefined,
    tagId: undefined,
    otherPointId: undefined,
    discountProductId: undefined,
    browseUrl: undefined,
    condition: undefined,
    subCondition: undefined,
    conditionValue: undefined,
    rewardPoints: undefined,
    rewardProducts: [],
  };

  loading: boolean = false;

  get isMissionStarted() {
    return this.form.startOn && new Date() > new Date(this.form.startOn);
  }

  async submit(form: MissionViewModel) {
    if (form) {
      this.loading = true;
      const { status } = await update(this.missionId, form);

      this.loading = false;
      if (status === 1) {
        await this.$router.back();
      }
    }
  }

  private setForm(data: MissionViewModel) {
    this.isValueSetted = true;
    this.form = data;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: MissionEdit) => void) => void,
  ) {
    const { missionId } = to.params;
    const { data } = await get(missionId);
    if (data.startOn) {
      data.startOn = moment(data.startOn).format('YYYY-MM-DD');
    }
    if (data.endOn) {
      data.endOn = moment(data.endOn).format('YYYY-MM-DD');
    }
    await next(async (vm) => {
      vm.setForm(data as MissionViewModel);
    });
  }
}
